// extracted by mini-css-extract-plugin
export var displayNone = "_r0-6";
export var imgContainer = "_r0-2";
export var overflowHidden = "_r0-3";
export var productInfoCardButtonContainer = "_r0-5";
export var productTitleText = "_r0-4";
export var rightArrow = "_r0-1";
export var rightArrowContainer = "_r0-0";